module.exports = __webpack_public_path__ + "img/all-device-mockup.cb1aee44.png";